module.exports = __webpack_public_path__ + "media/svg/bulletpoint-e3561165.svg";